<template>
  <div class="modal-out">
    <div class="modal" style="width: 1000px">
      <div class="modal-header">
        <div class="title">轨迹</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <div>

          <div style="float:right;padding-right: 10px">
            <el-date-picker style="margin-right: 10px;width:210px;" title="起止时间" size="mini"
                            v-model="startEndTime"
                            type="daterange"
                            value-format="yyyy-MM-dd"
                            format="yyyy-MM-dd"
                            :clearable="false"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间">
            </el-date-picker>
            <el-button size="mini" type="primary" @click="getList">搜索</el-button>
          </div>
          <div style="clear:both;"></div>

        </div>


        <div v-show="isShow" class="hint">
          获取轨迹中,请等待。。。
        </div>

        <div style="padding: 10px;">
          <baidu-map @ready="handler"
              class="map"
              :center="center"
              :zoom="12"
              :scroll-wheel-zoom="true"
              :mapClick="false">

<!--            <bm-marker :position="center" animation="BMAP_ANIMATION_BOUNCE"></bm-marker>-->

<!--            <bm-polyline :path="locationList" stroke-color="rgba(29, 211, 138, 1)"-->
<!--                         :stroke-opacity="1" :stroke-weight="3"></bm-polyline>-->


            <bm-polyline :path="locationList" stroke-color="blue" :stroke-opacity="1" :stroke-weight="3"></bm-polyline>
            <div v-for="(point, index) in locationList" :key="index">
              <bm-marker v-if="getViewOrNot(index)" :position="point" :icon="getPosIcon(index)"></bm-marker>
            </div>

          </baidu-map>
        </div>


      </div>
<!--      <div class="modal-footer">-->
<!--        <el-button :loading="loading" type="primary" @click="confirm('editForm')">修改</el-button>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>

import {timefilters, timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

import pos1 from "@/assets/number/pos-1.png";
import pos2 from "@/assets/number/pos-2.png";
import pos3 from "@/assets/number/pos-3.png";
import pos4 from "@/assets/number/pos-4.png";
import pos5 from "@/assets/number/pos-5.png";
import pos6 from "@/assets/number/pos-6.png";
import pos7 from "@/assets/number/pos-7.png";
import pos8 from "@/assets/number/pos-8.png";
import pos9 from "@/assets/number/pos-9.png";

export default {
  name: 'Add',
  props:[],
  data() {
    return {
      tableLoading: false,

      userCode:'',

      startEndTime:[],

      isShow:false,
      locationList:[],
      center: {
        lng: '117.309237',
        lat: '31.858271'
      },


      pos1:pos1,
      pos2:pos2,
      pos3:pos3,
      pos4:pos4,
      pos5:pos5,
      pos6:pos6,
      pos7:pos7,
      pos8:pos8,
      pos9:pos9,


    }
  },

  methods: {
    init(row){

      this.userCode = row.userCode;

      const now = new Date();
      const start = new Date(now - 1000 * 60 * 60 * 24 * 30);
      const end = new Date(now);
      this.startEndTime = [timefilters(start).substring(0,10), timefilters(end).substring(0,10)];

      this.locationList = [];
      this.center = {
        lng: '117.309237',
        lat: '31.858271'
      }


      this.getList();

    },

    closeSelf() {
      this.$emit("closeMe");
    },

    getList(){

      var _this=this
      this.isShow=true

      this.$axios({
        method: 'post',
        url: this.$shopUrl + "UserLonLat/ListBySpanTime",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          userCode:this.userCode,
          startTime:this.startEndTime[0],
          endTime:this.startEndTime[1],
        }
      }).then((response) => {
        _this.isShow=false
        if (response.data.error == 0) {
          let list = response.data.data.list;

          //console.log(response.data.data)
          if(list.length==0 ){
            this.$message({type: 'info', message: '该时间段无运动轨迹'});
          }else {

            var data2 = JSON.stringify(list);
            this.locationList = JSON.parse(data2.replace(/lon/g, 'lng'));

            this.center.lat=this.locationList[0].lat;
            this.center.lng=this.locationList[0].lng;

          }

        }
      }).catch(function (error) {
        //_this.tableLoading=false
        console.log(error);
      });
    },

    handler({ BMap, map }){

      // 添加缩放控件
      map.addControl(new BMap.NavigationControl());

    },

    getViewOrNot(index){
      let rv = true;
      index++;

      let len = this.locationList.length;
      if(len>=10){
        let part = Math.ceil(len/9);

        let mod = index % part;

        if(mod != 0){
          rv = false;
        }

      }

      console.log(index,rv);

      return rv;
    },
    getNumImg(index){
      let url = '';
      if(index == 1){
        url = this.pos1;
      }
      if(index == 2){
        url = this.pos2;
      }
      if(index == 3){
        url = this.pos3;
      }
      if(index == 4){
        url = this.pos4;
      }
      if(index == 5){
        url = this.pos5;
      }
      if(index == 6){
        url = this.pos6;
      }
      if(index == 7){
        url = this.pos7;
      }
      if(index == 8){
        url = this.pos8;
      }
      if(index == 9){
        url = this.pos9;
      }
      return url;
    },
    getPosIcon(index){
      index++;

      let len = this.locationList.length;
      let icon = {url:'',size:{width:64, height:64}};

      if(len<10){
        icon.url = this.getNumImg(index);
        return icon;
      }
      else{

        if(len>=10){
          let part = Math.ceil(len/9);

          let div =  Math.floor(index / part);
          let mod = index % part;
          if(mod == 0){
            console.log(index);
            icon.url = this.getNumImg(div);
            return icon;
          }

        }

      }




    },



  }
}


</script>

<style lang="scss" scoped>

.map{
  width: 100%;
  height: 450px;
}
.body{
  position: relative;
}
.hint{
  position: absolute;
  z-index: 1000;
  color: red;
  font-size: 20px;
  margin: 10px;
  // background: #F2F6FC;
}
</style>
